module.exports = __webpack_public_path__ + "img/democraticrepublicofcongo.9b5b0dfb.svg";